import { getConfig } from '../utils/getConfig';

/**
 * Build the Firebase SDK config object from `FIREBASE_*` env vars (via getConfig).
 * Pure and side-effect-free — no SDK import — so it is unit-testable without the emulator or mocks.
 */
export function getFirebaseConfig() {
  return {
    apiKey: getConfig('FIREBASE_API_KEY'),
    authDomain: getConfig('FIREBASE_AUTH_DOMAIN'),
    projectId: getConfig('FIREBASE_PROJECT_ID'),
    storageBucket: getConfig('FIREBASE_STORAGE_BUCKET'),
    messagingSenderId: getConfig('FIREBASE_MESSAGING_SENDER_ID'),
    appId: getConfig('FIREBASE_APP_ID')
  };
}
